<template>

    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" :class="showToggled ? 'toggled' : ''"
        id="accordionSidebar">
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle"
            style=" display: flex;align-self: flex-start;margin-top:10px;" v-if="!showToggled" @click="showHideMenu">
            <i class="fa fa-bars"></i>
        </button>
        <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
            <div class="sidebar-brand-text mx-3">
                <LogoNegative formatting="logo-center" width="130px"></LogoNegative>
            </div>
        </a>
        <hr class="sidebar-divider my-0">
        <li class="nav-item" :class="route == '/' ? 'active' : ''">
            <router-link class="nav-link" to="/">
                <i class="fas fa-fw fa-home"></i>
                <span>Início</span></router-link>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item" v-if="type_client == 'pf'">
            <router-link class="nav-link" @click="itemSelectec('client_pf')"
                :class="route == 'client_pf' ? 'active' : ''" :to="{
                    name: 'client_pf',
                    params: { id: client_id, type: type_client }
                }">
                <i class="fas fa-fw fa-info-circle"></i>
                <span>Meus dados</span></router-link>
        </li>
        <li class="nav-item" v-if="type_client == 'pj'">
            <router-link class="nav-link" @click="itemSelectec('client_pj')"
                :class="route == 'client_pj' ? 'active' : ''" :to="{
                    name: 'client_pj',
                    params: { id: client_id, type: type_client }
                }">
                <i class="fas fa-fw fa-info-circle"></i>
                <span>Meus dados</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="type_client == 'pj'">
        <li class="nav-item" v-if="type_client == 'pj'">
            <router-link class="nav-link" @click="itemSelectec('client_structure_corporate')"
                :class="route == 'client_structure_corporate' ? 'active' : ''" :to="{
                    name: 'client_structure_corporate',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-list-alt"></i>
                <span>QSA</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="menu_certificate == 'true'">
        <li class="nav-item" v-if="menu_certificate == 'true'">
            <router-link class="nav-link" @click="itemSelectec('client_certificate')"
                :class="route == 'client_certificate' ? 'active' : ''" :to="{
                    name: 'client_certificate',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-certificate"></i>
                <span>Certificados</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="menu_fiscal == 'true'">
        <li class="nav-item" v-if="menu_fiscal == 'true'">
            <router-link class="nav-link" @click="itemSelectec('client_fiscal')"
                :class="route == 'client_fiscal' ? 'active' : ''" :to="{
                    name: 'client_fiscal',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-percent"></i>
                <span>Dados fiscais</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="menu_service == 'true'">
        <li class="nav-item" v-if="menu_service == 'true'">
            <router-link class="nav-link" @click="itemSelectec('client_service')"
                :class="route == 'client_service' ? 'active' : ''" :to="{
                    name: 'client_service',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-handshake"></i>
                <span>Contratos</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="menu_document == 'true'">
        <li class="nav-item" v-if="menu_document == 'true'">
            <router-link class="nav-link" @click="itemSelectec('client_file')"
                :class="route == 'client_file' ? 'active' : ''" :to="{
                    name: 'client_file',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-file"></i>
                <span>Meus Documentos</span></router-link>
        </li>
         <li class="nav-item" v-if="menu_link == 'true'">
            <router-link class="nav-link" @click="itemSelectec('link')"
                :class="route == 'link' ? 'active' : ''" :to="{
                    name: 'link',
                    params: { id: client_id }
                }">
                <i class="fas fa-fw fa-link"></i>
                <span>{{ this.name_menu_link }}</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="menu_financial == 'true'">
        <li class="nav-item" v-if="menu_financial == 'true'">
            <router-link class="nav-link" @click="itemSelectec('financial')"
                :class="route == 'financial' ? 'active' : ''" :to="{
                    name: 'financial',
                    params: { id: client_id }
                }">
                <i class="fas fa-money-bill"></i>
                <span>Financeiro</span></router-link>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseProfile"
                aria-expanded="true" aria-controls="collapseProfile">
                <i class="fas fa-fw fa-user"></i>
                <span>Perfil</span>
            </a>
            <div id="collapseProfile" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">

                    <a class="collapse-item" href="#" @click="logout()">Sair</a>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider d-none d-md-block">

        <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle" @click="showHideMenu"></button>
        </div>
    </ul>
</template>

<script>
import api from '@/api';
import LogoNegative from '../img/logo-negative.vue';
import { menu } from '@/menu';

export default {
    components: { LogoNegative },
    data() {
        return {
            toggled: true,
            route: '',
            client_id: '',
            type_client: '',
            menu_certificate: false,
            menu_fiscal: false,
            menu_service: false,
            menu_document: false,
            menu_financial: false,
            menu_link:false,
            name_menu_link:'Link'
        }
    },
    computed: {
        showToggled: function () {
            return !menu.toggled;
        }
    },
    beforeMount() {
        this.client_id = localStorage.getItem('client_id');
        if(this.client_id == null){
            this.client_id = -1;
        }
        this.type_client = localStorage.getItem('type');
        this.menu_certificate =  process.env.VUE_APP_CERTIFICATE;
        this.menu_fiscal = process.env.VUE_APP_FISCAL;
        this.menu_service = process.env.VUE_APP_SERVICE;
        this.menu_document = process.env.VUE_APP_DOCUMENT;
        this.menu_financial = process.env.VUE_APP_FINANCIAL;
        this.menu_link = process.env.VUE_APP_LINK;
        this.name_menu_link = process.env.VUE_APP_NAME_MENU_LINK;
       
    },
    mounted() {
        this.isLoading = false;
       
    },

    methods: {
        itemSelectec(item) {
            if(this.client_id == null){
               this.client_id = localStorage.getItem('client_id');
            }
            this.route = item;
            const collapse = document.querySelectorAll('.collapse_menu');
            collapse.forEach(div => {
                div.className = "";
                div.className = "collapse collapse_menu";
            });
        },
        showHideMenu() {
            this.toggled = !this.toggled;
        },
        logout() {
            api.post('/auth/logout')
                .then(() => {
                    this.$notify({
                        title: "Sucesso",
                        text: "Sessão encerrada com sucesso!",
                        type: 'success'
                    });
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    localStorage.removeItem('email');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    localStorage.removeItem('expire_in');
                    localStorage.removeItem('change_password');
                    localStorage.removeItem('client_id');
                    localStorage.removeItem('type');
                    localStorage.removeItem('term_use');
                    localStorage.removeItem('text_term_use');

                    this.$router.push('/login');
                }).catch(error => {
                    if (error.status == 401) {
                        this.$notify({
                            title: "Falha",
                            text: "Sessão já encerrada!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 429) {
                        this.$notify({
                            title: "Falha",
                            text: "Foram realizadas várias tentativas de finalização de sessão! Aguarde alguns instantes e tente novamente!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 500) {
                        this.$notify({
                            title: "Falha",
                            text: "Não foi possível encerrar a sessão! Por gentileza, contacte o suporte técnico para mais detalhes",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    }

                })
        },
    }
}
</script>

<style>
.active {
    font-weight: bold;
}

.navbar-nav {
    z-index: 2;
}
</style>